import React from 'react';
//import { TransitionGroup, CSSTransition } from 'react-transition-group';
import SeverityLevel from './SeverityLevel';
import Helpers from '../helpers/util';

class BarIndicator extends React.Component {
	constructor() {
		super();

		this.state = {
			isRanked: false,
			isVisible: false,
			name: '',
		};
	}

	componentWillMount() {
		Helpers.pubsub.subscribe('barIndicator', (data) => {
			if (data.name) {
				this.setState({ isRanked: data.is_ranked, isVisible: data.show, name: data.name });
			} else {
				this.setState({ isVisible: data.show });
			}
		});
	}

	render() {
		return (
			<div className={`legend legend--bar-indicator ${this.state.isVisible ? 'legend--visible' : 'legend--hidden'}`}>
				<div className="legend__title">
					<span>
						{this.state.name} {this.state.isRanked ? 'Disease Risk Level' : 'Prevalence'}
					</span>
				</div>
				{this.state.isRanked ? (
					<div className="legend__items">
						<SeverityLevel level={4} text="High" />
						<SeverityLevel level={2} text="Medium" />
						<SeverityLevel level={1} text="Low" />
						<SeverityLevel level={-1} text="No data" />
					</div>
				) : (
					<div className="legend__items">
						<SeverityLevel level={5} text="Country with known disease risk" />
						<SeverityLevel level={0} text="Country with no known or low disease risk" />
						<SeverityLevel level={-1} text="No data" />
					</div>
				)}
			</div>
		);
	}
}

export default BarIndicator;
